/* eslint-disable react-hooks/exhaustive-deps */

import axios from 'axios'
import React, { ReactElement, useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import humps from 'humps'
import { useConnectedUserContext } from '../contexts/connected-user'
import Loading from '../components/loading'
import { Admin } from '../types/user'

const ProtectedRoutes = (): ReactElement => {
  const location = useLocation()
  const { connectedUser, setConnectedUser } = useConnectedUserContext()
  const [loading, setLoading] = useState(true)

  localStorage.setItem('redirectUrl', location.pathname)

  const connectedUserToken = localStorage.token ? localStorage.token : undefined
  useEffect(() => {
    if (connectedUserToken) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/admin/moderator`, {
          headers: { 'x-access-token': `${connectedUserToken}` },
        })
        .then((result) => {
          if ((result.data as unknown as Admin).isAdmin) {
            setConnectedUser(
              humps.camelizeKeys(result.data) as unknown as Admin
            )
            setLoading(false)
          }
        })
        .catch(() => {
          setLoading(false)
          localStorage.removeItem('token')
        })
    } else {
      localStorage.removeItem('token')
      setLoading(false)
    }
  }, [])

  if (loading) {
    return <Loading />
  }

  if (connectedUser) {
    return <Outlet />
  }

  return <Navigate to="/" />
}

export default ProtectedRoutes
